import { components } from 'react-select'
import React from 'react'
import {
  colors,
  fontSize,
  fontWeight,
  spacing,
  Text,
  Tooltip,
} from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { Divider } from '../../../utils/common.styles.tsx'
import {
  FeatureConfigDetails,
  FeatureConfigTagDetails,
} from '../util/qualityAuditWorkflowConfigFeatureDetails.tsx'

export const FeatureDetailPill = styled.div({
  fontSize: fontSize.X15,
  padding: '3px 8px',
  justifyContent: 'center',
  display: 'inline-flex',
  cursor: 'pointer',
  borderRadius: '14px',
  backgroundColor: colors.GRAYSCALE.X20,
  fontWeight: fontWeight.SEMIBOLD,
  color: colors.GRAYSCALE.X70,
})

export const QualityAuditWorkflowConfigColumnModalFeatureSelect = (
  props: any | { data: { label: string; value: string } } | undefined
) => {
  const data = props?.data
  const featureDetails = FeatureConfigDetails?.[data?.label]
  if (!featureDetails) return null
  return (
    <>
      <components.Option {...props}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            gap: `${spacing.X8}`,
          }}
        >
          <Text
            size={'medium'}
            weight={'bold'}
            css={{
              paddingRight: `${spacing.X16}`,
              marginRight: `${spacing.X16}`,
            }}
          >
            {data.label}
          </Text>
          <Text size={'medium'} weight={'regular'}>
            {featureDetails.shortDescription}
          </Text>
          <div
            css={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: `${spacing.X4}`,
            }}
          >
            {featureDetails?.type && (
              <FeatureDetailPill style={{ backgroundColor: colors.SUCCESS.LIGHT }}>
                {featureDetails?.type}
              </FeatureDetailPill>
            )}
            {(featureDetails?.tags ?? []).map(tag => (
              <Tooltip key={tag} target={<FeatureDetailPill key={tag}>{tag}</FeatureDetailPill>}>
                {FeatureConfigTagDetails?.[tag]?.description}
              </Tooltip>
            ))}
          </div>
        </div>
      </components.Option>
      <Divider />
    </>
  )
}
